module.exports = __webpack_public_path__ + "img/button_speech_muted.39c396e5.svg";